import { apiService } from '../_services'

export const castleService={
  getCastle,
  getCastleSummary,
  saveCastle
}

function getCastle(){
  return apiService.fetchAuthGet('castle')
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function getCastleSummary(){
  return apiService.fetchAuthGet('castle/summary')
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function saveCastle(castle){
  console.log(castle)
  return apiService.fetchAuthPost('castle',castle)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
